import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";

import * as authActions from "./authActions";
import * as authSelectors from "./authSelectors";
import { LoginForm } from "./LoginForm";

export const Login = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(authSelectors.isAuthenticating);
  const hasUsernameOrPasswordError = useSelector(
    authSelectors.hasErrorWrongUsernameOrPassword
  );
  const isAuthenticating = useSelector(authSelectors.isAuthenticating);
  const isSelectingOrganization = useSelector(
    authSelectors.isSelectingOrganization
  );

  const doLogin = (username: string, password: string) => {
    dispatch(authActions.authLoginAction(username, password));
  };

  const isDimmerActive = isAuthenticating || isSelectingOrganization;

  const onFormSubmit = (values: { username: string; password: string }) => {
    doLogin(values.username, values.password);
  };

  return (
    <div className="page">
      <div className="page-single">
        <div className="container">
          <div className="row">
            <div className="col col-login mx-auto">
              <div className="card">
                <div className="card-body p-6">
                  <div className={clsx("dimmer", { active: isDimmerActive })}>
                    <div className="loader" />

                    <div className="dimmer-content">
                      <LoginForm
                        onSubmit={onFormSubmit}
                        isLoading={isLoading}
                        hasUsernameOrPasswordError={hasUsernameOrPasswordError}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
